import { render, staticRenderFns } from "./ChurnDataModal.vue?vue&type=template&id=96ed99ae&scoped=true&"
import script from "./ChurnDataModal.vue?vue&type=script&lang=ts&"
export * from "./ChurnDataModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96ed99ae",
  null
  
)

export default component.exports